import { EqxLoading } from '@equinoxx/react'
import { PageErrorNoRouting } from '../../pages/PageError'
import useApiEndpoint from '../../shared/hooks/ApiEndpoint'
import generateContextProvider, { ContextProviderWrapperProps } from '../../shared/hooks/GenerateContextProvider'
import { useApiContext } from './AppApi'
import { useTenantID } from './AppTenantID'

interface AppTenant {
    id: string
    name: string
    aadClientID: string
    aadTenantID: string
}
const AppTenantWrapper = (props: ContextProviderWrapperProps<AppTenant>) => {
    const TenantProvider = props.provider
    const api = useApiContext()
    const tenantID = useTenantID()
    const confEndpoint = api.endpoints.config()
    const {
        status,
        response: loadedConfig,
        loading,
        error,
    } = useApiEndpoint(api, confEndpoint, true)

    //handle loading or error
    if (loading) return <EqxLoading />
    if (error) return <PageErrorNoRouting error="Error loading config" />

    const Tenant: AppTenant = {
        id: tenantID,
        name: loadedConfig!.tenantName,
        aadClientID: loadedConfig!.aadClientID,
        aadTenantID: loadedConfig!.aadTenantID,
    }

    //pass auth on to the children
    return <TenantProvider value={Tenant}>{props.children}</TenantProvider>
}

const { ContextProvider: AppTenantProvider, useContext: useTenantContext } = generateContextProvider<AppTenant>(
    undefined,
    AppTenantWrapper
)

export { AppTenantProvider as default, useTenantContext, type AppTenant }

